export const LOADER_FORMEVALCAPA =          "LOADER_FORMEVALCAPA";
export const GET_FORMEVALCAPA =             "GET_FORMEVALCAPA";
export const FORMEVALCAPA_FAIL =            "FORMEVALCAPA_FAIL";
export const FORM_FORMEVALCAPA_FAIL =       "FORM_FORMEVALCAPA_FAIL";
export const SAVE_LOADER_FORMEVALCAPA =     "SAVE_LOADER_FORMEVALCAPA";
